<template>
  <el-row class="m-0 width-100-p mt-3">
    <el-col class="d-flex align-item-center px-2" :span="24">
      <div
        :class="$vuetify.display.width < 1500 ? 'row m-0 width-100-p' : 'row m-0 width-100-p px-2'">
        <div
          class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
        >
          <el-col class="mb-2 px-0" :span="24">
            <div class="row m-0" :span="24">
              <el-row :gutter="$vuetify.display.width > 1500 ? 20 : 10">
                <el-col :span="24">
                  <h5 class="text-white mt-3 ml-1">{{chargerFilter == 1 ? 'Charger Schedule' : chargerFilter == 2 ? 'Charging Sites' : chargerFilter == 3 ? 'Chargers' : 'Ports'}}</h5>
                </el-col>
              <!-- table tabs radio group -->
              <el-col
              :span="$vuetify.display.width > 1500 ? 8 : 22"
              :class="'x-start order-1 mb-10'"
              >
                <el-radio-group
                  v-model="chargerFilter"
                  @change="selectChargerFilter"
                  text-color="#ffff"
                  fill="#234B49"
                  :class="$vuetify.display.width < 800 ? 'width-100-p' : ''"
                  :style="$vuetify.display.width < 800 ? 'display: flex;' : 'display: flex; gap:0px; white-space: nowrap;'"
                >
                  <el-radio-button
                    class="start-period all-group-by text-center"
                    label="1"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 80px;'"
                  >
                    All
                  </el-radio-button>
                  <el-radio-button
                    class="site-group-by text-center"
                    label="2"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 120px;'"
                  >
                    {{ $vuetify.display.width < 805 ? 'Site' : 'Charging Site' }}
                  </el-radio-button>
                  <el-radio-button
                    class="charger-group-by text-center"
                    label="3"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 100px;'"
                  >
                    Chargers
                  </el-radio-button>
                  <el-radio-button
                    class="port-group-by text-center end-period"
                    label="4"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 90px;'"
                  >
                    Ports
                  </el-radio-button>
                </el-radio-group>
              </el-col>

             <!--  search input -->
             <el-col
                :span="$vuetify.display.width > 1500 ? 15 : 24"
                :class="$vuetify.display.width > 1500 ? 'x-start order-2 mb-10 pr-20' : 'x-start order-3 mb-10'"
              >
                  <el-input
                    size="large"
                    v-model="search"
                    :placeholder=" (convertLabel(filter.elec_region) == '' || convertLabel(filter.elec_region) == 'all' ? '' : 'Region: ' + convertShorterLabel(convertLabel(filter.elec_region), 7, 8) + ' &#x7c; ' ) + 'Search by: ' +  (convertLabel(selectedSearchBy) == ''? ' ' : convertLabel(selectedSearchBy)) "
                    :prefix-icon="Search"
                    class="mixedSearchBar"
                    id="mixedSearchBar-input"
                    clearable
                    @clear="handleRefresh"
                  >
                    <template #prepend>

                      <!-- search_by select -->
                      <el-tooltip
                        effect="light"
                        placement="top"
                        show-after="500"
                        hide-after="300"
                        >
                        <template #content > 
                            <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                        </template>

                        <el-select
                          v-model="selectedSearchBy"
                          placeholder="Select"
                          style="min-width: 117px; height: 40px;"
                          @change="handleSelectSearchBy"
                          class="mixedSearchBar-select"
                        >
                          <template #label>
                            <span>Search by: </span>
                            <span style="font-weight: bold">{{ convertLabel(selectedSearchBy) }}</span>
                          </template>
                          <el-option
                            v-for="(item, index) in search_by_dropdown[$store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 1 ? 'admin_all' : selectedTableTab]"
                            :key="index"
                            :label="convertLabel(item)"
                            :value="item"
                          />
                        </el-select>
                      </el-tooltip>
                    </template>
                    
                    <template #append>
                      <!-- <el-button :icon="Search" /> -->
                      <el-button
                          @click.stop="handleRefresh"
                          class="newSearchButtonClass"
                        >
                        <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                      </el-button>
                    </template>
                  </el-input>
              </el-col>
             <!--  search input -->

              <!-- download excel button -->
              <el-col
                :class="$vuetify.display.width > 1500 ? 'd-flex justify-content-end order-3' : 'justify-content-end order-2'"
                :span="$vuetify.display.width > 1500 ? 1 : 2"
              >
                <el-button
                  v-if="
                    $store.state.auth.user != null &&
                    $store.state.auth.user.is_admin 
                  "
                  @click="handleExportFile"
                  class="new-download-file-btn new-button-behavior"
                >
                  <svg class="width-40 height-40">
                    <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                  </svg>
                </el-button>
              </el-col>
              </el-row>
            </div>
          </el-col>

          <!-- four tables -->
          <el-col :span="24">
            <div
              class="ma-0"
              v-loading="loading"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <!-- All List -->
              <div class="custom-table-design" v-if="chargerFilter == 1">
                <el-table
                  
                  :data="AllDataList"
                  stripe
                  :fit="true"
                  height="650"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Site Name'"
                    :prop="'site_name'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="160"
                    sortable
                    v-if="chargerFilter"
                  />
                  <el-table-column
                    :label="'Charger ID'"
                    :prop="'charger_name'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Port ID'"
                    :prop="'port_id'"
                    :width="$vuetify.display.width <= 2600 ? 150 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'Charger Type'"
                    :prop="'charger_type'"
                    :width="$vuetify.display.width <= 2600 ? 180 : ''"
                    :min-width="180"
                    sortable
                  >
                    <template #default="scope">
                      <el-tag
                        :type="
                          scope.row.charger_type.toString().toUpperCase() === 'AC'
                            ? 'success'
                            : 'danger'
                        "
                        disable-transitions
                      >
                        {{ scope.row.charger_type.toString().toUpperCase() }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Charger Capacity (kW)'"
                    :prop="'charger_capacity_kW'"
                    :width="$vuetify.display.width <= 2600 ? 250 : ''"
                    :min-width="250"
                    sortable
                  >
                  <template #default="scope">
                    {{
                    scope.row.charger_capacity_kW == null
                        ? ""
                        : Number(scope.row.charger_capacity_kW).toLocaleString()
                    }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Port Type'"
                    :prop="'port_type'"
                    :width="$vuetify.display.width <= 2600 ? 160 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Port Capacity (kW)'"
                    :prop="'port_capacity_kw'"
                    :width="$vuetify.display.width <= 2600 ? 230 : ''"
                    :min-width="230"
                    sortable
                  >
                  <template #default="scope">
                    {{
                    scope.row.port_capacity_kw == null
                        ? ""
                        : Number(scope.row.port_capacity_kw).toLocaleString()
                    }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Make'"
                    :prop="'make'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'Model'"
                    :prop="'model'"
                    :width="$vuetify.display.width <= 2600 ? 170 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'Charging Partner'"
                    :prop="'charging_partner'"
                    :width="$vuetify.display.width <= 2600 ? 220 : ''"
                    :min-width="220"
                    sortable
                  />
                  <el-table-column
                    :label="'Address Comment'"
                    :prop="'address_comment'"
                    :width="$vuetify.display.width <= 2600 ? 210 : ''"
                    :min-width="210"
                    sortable
                  />
                  <el-table-column
                    :label="'Street Number'"
                    :prop="'street_number'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="190"
                    sortable
                  />
                  <el-table-column
                    :label="'Street Name'"
                    :prop="'street_name'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Suburb'"
                    :prop="'suburb'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'City'"
                    :prop="'city'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="120"
                    sortable
                  />
                  <el-table-column
                    :label="'Postcode'"
                    :prop="'postcode'"
                    :width="$vuetify.display.width <= 2600 ? 180 : ''"
                    :min-width="150"
                    sortable
                  />
                  <el-table-column
                    :label="'State (County/Province)'"
                    :prop="'state'"
                    :width="$vuetify.display.width <= 2600 ? 280 : ''"
                    :min-width="280"
                    sortable
                  />
                  <el-table-column
                    :label="'Country'"
                    :prop="'country'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="150"
                    sortable
                  />
                  <el-table-column
                    :label="'Latitude'"
                    :prop="'lat'"
                    :width="$vuetify.display.width <= 2600 ? 210 : ''"
                    :min-width="150"
                    sortable
                  />
                  <el-table-column
                    :label="'Longitude'"
                    :prop="'lng'"
                    :width="$vuetify.display.width <= 2600 ? 210 : ''"
                    :min-width="160"
                    sortable
                  />
                  <!-- <el-table-column
                    :label="'What3words'"
                    :prop="'what3words'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="180"
                    sortable
                  /> -->
                  <el-table-column
                    :label="'Install Date'"
                    :prop="'install_date'"
                    :width="$vuetify.display.width <= 2600 ? 180 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Operational Date'"
                    :prop="'operational_date'"
                    :width="$vuetify.display.width <= 2600 ? 220 : ''"
                    :min-width="220"
                    sortable
                  />
                  <el-table-column
                    :label="'Decommissioning Date'"
                    :prop="'decommissioning_date'"
                    :width="$vuetify.display.width <= 2600 ? 250 : ''"
                    :min-width="250"
                    sortable
                  />
                  <el-table-column
                    :label="'On-Site Renewable'"
                    :prop="'onsite_renewable'"
                    :width="$vuetify.display.width <= 2600 ? 230 : ''"
                    :min-width="230"
                    sortable
                  >
                    <template #default="scope">
                      <svg v-if="scope.row.onsite_renewable.toString().toUpperCase() ==
                            'TRUE' ||
                          scope.row.onsite_renewable.toString().toUpperCase() ==
                            'YES'" id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                      </svg>
                      <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                      </svg>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Battery'"
                    :prop="'onsite_battery'"
                    :width="$vuetify.display.width <= 2600 ? 170 : ''"
                    :min-width="140"
                    sortable
                  >
                    <template #default="scope">
                      <svg v-if="scope.row.onsite_battery.toString().toUpperCase() ==
                            'TRUE' ||
                          scope.row.onsite_battery.toString().toUpperCase() ==
                            'YES'" id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                      </svg>
                      <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                      </svg>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Site Description'"
                    :prop="'site_description'"
                    :width="$vuetify.display.width <= 2600 ? 220 : ''"
                    :min-width="220"
                    sortable
                  />
                  <el-table-column
                    :label="'Charger Description'"
                    :prop="'charger_description'"
                    :width="$vuetify.display.width <= 2600 ? 240 : ''"
                    :min-width="240"
                    sortable
                  />
                  <el-table-column
                    :label="'Port Description'"
                    :prop="'port_description'"
                    :width="$vuetify.display.width <= 2600 ? 220 : ''"
                    :min-width="220"
                    sortable
                  />
                  <el-table-column
                    :label="'Customer'"
                    :prop="'customer'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="150"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  />
                  <el-table-column
                    :label="'Elec Region'"
                    :prop="'elec_region'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="170"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.elec_region == null
                          ? ""
                          : (scope.row.elec_region).toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Certificate Number"
                    :prop="'certificate_number'"
                    :width="$vuetify.display.width <= 2600 ? 230 : ''"
                    :min-width="230"
                    sortable
                  >
                    <template #default="scope">
                      <el-tooltip
                        v-if="scope.row.certificate_number"
                        effect="light"
                        placement="top"
                        :show-after="400"
                      >
                        <template #content>
                          <span style="word-break: break-all;">{{ scope.row.certificate_number }}</span>
                        </template>
                        <a
                          :href="scope.row.certificate_number.toLowerCase()"
                          target="_blank"
                          class="truncated-cell-link"
                        >
                          {{ scope.row.certificate_number }}
                        </a>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Validation Link "
                    :prop="'validation_link'"
                    :width="$vuetify.display.width <= 2600 ? 220 : ''"
                    :min-width="220"
                    sortable
                  >
                    <template #default="scope">
                      <el-tooltip
                        v-if="scope.row.validation_link"
                        effect="light"
                        placement="top"
                        :show-after="400"
                      >
                        <template #content>
                          <span style="word-break: break-all;">{{ scope.row.validation_link }}</span>
                        </template>
                        <a
                          :href="scope.row.validation_link"
                          target="_blank"
                          class="truncated-cell-link"
                        >
                          {{ scope.row.validation_link }}
                        </a>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Year Added'"
                    :prop="'year_added'"
                    :width="$vuetify.display.width <= 2600 ? 160 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Active Until'"
                    :prop="'active_until'"
                    :width="$vuetify.display.width <= 2600 ? 180 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Is Included'"
                    :prop="'included_in_project'"
                    :width="$vuetify.display.width <= 2600 ? 170 : ''"
                    :min-width="170"
                    sortable
                  >
                  <template #default="scope">
                      <svg v-if="scope.row.included_in_project.toString().toUpperCase() ==
                            'TRUE' ||
                          scope.row.included_in_project.toString().toUpperCase() ==
                            'YES'" id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                      </svg>
                      <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                      </svg>
                    </template>
                  </el-table-column>
                  <el-table-column
                  v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 1
                    "
                    :label="'Created At'"
                    :prop="'created_at'"
                    :width="$vuetify.display.width <= 2600 ? 210 : ''"
                    :min-width="160"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.created_at == null
                          ? ""
                          : scope.row.created_at.replace("T", " ").substring(0, 19)
                      }}
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                  v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 1
                    "
                    :label="'Updated At'"
                    :prop="'updated_at'"
                    :width="$vuetify.display.width <= 2600 ? 210 : ''"
                    :min-width="160"
                    sortable
                  >
                  <template #default="scope">
                      {{
                      scope.row.updated_at == null
                          ? ""
                          : scope.row.updated_at.replace("T", " ").substring(0, 19)
                      }}
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    :label="'Change Date'"
                    :prop="'change_date'"
                    :width="$vuetify.display.width <= 2600 ? 170 : ''"
                    :min-width="170"
                    sortable
                  />
                  <el-table-column
                    :label="'Change Details'"
                    :prop="'change_details'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="200"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.change_details == null
                          ? ""
                          : scope.row.change_details.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Change Type'"
                    :prop="'change_type'"
                    :width="$vuetify.display.width <= 2600 ? 170 : ''"
                    :min-width="170"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.change_type == null
                          ? ""
                          : scope.row.change_type.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 1
                    "
                    :label="'Motion Site ID'"
                    :prop="'motion_site_id'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="200"
                    sortable
                  />
                  <el-table-column
                    v-if="
                      $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 1
                      "
                    :label="'Motion Charger ID'"
                    :prop="'motion_charger_id'"
                    :width="$vuetify.display.width <= 2600 ? 230 : ''"
                    :min-width="230"
                    sortable
                  />
                  <el-table-column
                    v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 1
                    "
                    :label="'Motion Port ID'"
                    :prop="'motion_port_id'"
                    :width="$vuetify.display.width <= 2600 ? 200 : ''"
                    :min-width="200"
                    sortable
                  />
                </el-table>
              </div>

                <!-- Charging Site -->
                <div class="custom-table-design" v-else-if="chargerFilter == 2">
                <el-table
                  stripe
                  :data="SiteDataList"
                  :fit="true"
                  height="650"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Site Name'"
                    :prop="'site_name'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="160"
                    sortable
                    v-if="chargerFilter"
                  />
                  <el-table-column
                    :label="'Address Comment'"
                    :prop="'address_comment'"
                    :width="$vuetify.display.width <= 2500 ? 400 : ''"
                    :min-width="210"
                    sortable
                  >
                    <template #default="scope">
                      <el-tooltip
                        v-if="scope.row.address_comment"
                        effect="light"
                        placement="top"
                        :show-after="400"
                      >
                        <template #content>
                          <span style="word-break: break-all;">{{ scope.row.address_comment }}</span>
                        </template>
                        <span class="truncated-cell-link">{{ scope.row.address_comment }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Street Number'"
                    :prop="'street_number'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="190"
                    sortable
                  />
                  <el-table-column
                    :label="'Street Name'"
                    :prop="'street_name'"
                    :width="$vuetify.display.width <= 2500 ? 190 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Suburb'"
                    :prop="'suburb'"
                    :width="$vuetify.display.width <= 2500 ? 180 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'City'"
                    :prop="'city'"
                    :width="$vuetify.display.width <= 2500 ? 180 : ''"
                    :min-width="120"
                    sortable
                  />
                  <el-table-column
                    :label="'Postcode'"
                    :prop="'postcode'"
                    :width="$vuetify.display.width <= 2500 ? 190 : ''"
                    :min-width="150"
                    sortable
                  />
                  <el-table-column
                    :label="'State (County/Province)'"
                    :prop="'state'"
                    :width="$vuetify.display.width <= 2500 ? 280 : ''"
                    :min-width="280"
                    sortable
                  />
                  <el-table-column
                    :label="'Country'"
                    :prop="'country'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="150"
                    sortable
                  />
                  <el-table-column
                    :label="'Description'"
                    :prop="'description'"
                    :width="$vuetify.display.width <= 2500 ? 210 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Customer'"
                    :prop="'customer'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="150"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  />
                  <el-table-column
                    :label="'Elec Region'"
                    :prop="'elec_region'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="170"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.elec_region == null
                          ? ""
                          : (scope.row.elec_region).toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Change Date'"
                    :prop="'change_date'"
                    :width="$vuetify.display.width <= 2500 ? 170 : ''"
                    :min-width="170"
                    sortable
                  />
                  <el-table-column
                    :label="'Change Details'"
                    :prop="'change_details'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="200"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.change_details == null
                          ? ""
                          : scope.row.change_details.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Change Type'"
                    :prop="'change_type'"
                    :width="$vuetify.display.width <= 2500 ? 170 : ''"
                    :min-width="170"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.change_type == null
                          ? ""
                          : scope.row.change_type.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Updated At'"
                    :prop="'site_updated_at'"
                    :width="$vuetify.display.width <= 2500 ? 250 : ''"
                    :min-width="160"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.site_updated_at == null
                          ? ""
                          : scope.row.site_updated_at.replace("T", " ").substring(0, 19)
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 2
                    "
                    :label="'Motion Site ID'"
                    :prop="'charger_site_id'"
                    :width="$vuetify.display.width <= 2500 ? 250 : ''"
                    :min-width="200"
                    sortable
                  />
                </el-table>
                </div>

                <!-- Chargers -->
                <div class="custom-table-design"  v-else-if="chargerFilter == 3">
                <el-table
                  stripe
                  :data="ChargerDataList"
                  :fit="true"
                  height="650"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Site Name'"
                    :prop="'site_name'"
                    :width="$vuetify.display.width <= 3000 ? 200 : ''"
                    :min-width="160"
                    sortable
                    v-if="chargerFilter"
                  />
                  <el-table-column
                    :label="'Charger ID'"
                    :prop="'charger_name'"
                    :width="$vuetify.display.width <= 3000 ? 200 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Charger Type'"
                    :prop="'charger_type'"
                    :width="$vuetify.display.width <= 3000 ? 180 : ''"
                    :min-width="180"
                    sortable
                  >
                    <template #default="scope">
                      <el-tag
                        :type="
                          scope.row.charger_type.toString().toUpperCase() === 'AC'
                            ? 'success'
                            : 'danger'
                        "
                        disable-transitions
                      >
                        {{ scope.row.charger_type.toString().toUpperCase() }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Charger Capacity (kW)'"
                    :prop="'charger_capacity_kW'"
                    :width="$vuetify.display.width <= 3000 ? 250 : ''"
                    :min-width="250"
                    sortable
                  >
                  <template #default="scope">
                    {{
                    scope.row.charger_capacity_kW == null
                        ? ""
                        : Number(scope.row.charger_capacity_kW).toLocaleString()
                    }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Make'"
                    :prop="'make'"
                    :width="$vuetify.display.width <= 3000 ? 200 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'Model'"
                    :prop="'model'"
                    :width="$vuetify.display.width <= 3000 ? 170 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'Charging Partner'"
                    :prop="'charging_partner'"
                    :width="$vuetify.display.width <= 3000 ? 220 : ''"
                    :min-width="220"
                    sortable
                  />
                  <el-table-column
                    :label="'Install Date'"
                    :prop="'install_date'"
                    :width="$vuetify.display.width <= 3000 ? 180 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Operational Date'"
                    :prop="'operational_date'"
                    :width="$vuetify.display.width <= 3000 ? 220 : ''"
                    :min-width="220"
                    sortable
                  />
                  <el-table-column
                    :label="'Decommissioning Date'"
                    :prop="'decommissioning_date'"
                    :width="$vuetify.display.width <= 3000 ? 250 : ''"
                    :min-width="250"
                    sortable
                  />
                  <el-table-column
                    :label="'On-Site Renewable'"
                    :prop="'onsite_renewable'"
                    :width="$vuetify.display.width <= 3000 ? 230 : ''"
                    :min-width="230"
                    sortable
                  >
                    <template #default="scope">
                      <svg v-if="scope.row.onsite_renewable.toString().toUpperCase() ==
                            'TRUE' ||
                          scope.row.onsite_renewable.toString().toUpperCase() ==
                            'YES'" id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                      </svg>
                      <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                      </svg>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Battery'"
                    :prop="'onsite_battery'"
                    :width="$vuetify.display.width <= 3000 ? 170 : ''"
                    :min-width="140"
                    sortable
                  >
                    <template #default="scope">
                      <svg v-if="scope.row.onsite_battery.toString().toUpperCase() ==
                            'TRUE' ||
                          scope.row.onsite_battery.toString().toUpperCase() ==
                            'YES'" id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                      </svg>
                      <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                      </svg>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Description'"
                    :prop="'description'"
                    :width="$vuetify.display.width <= 3000 ? 210 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Customer'"
                    :prop="'customer'"
                    :width="$vuetify.display.width <= 3000 ? 200 : ''"
                    :min-width="150"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  />
                  <el-table-column
                    label="Certificate Number"
                    :prop="'certificate_number'"
                    :width="$vuetify.display.width <= 2600 ? 230 : ''"
                    :min-width="230"
                    sortable
                  >
                    <template #default="scope">
                      <el-tooltip
                        v-if="scope.row.certificate_number"
                        effect="light"
                        placement="top"
                        :show-after="400"
                      >
                        <template #content>
                          <span style="word-break: break-all;">{{ scope.row.certificate_number }}</span>
                        </template>
                        <a
                          :href="scope.row.certificate_number.toLowerCase()"
                          target="_blank"
                          class="truncated-cell-link"
                        >
                          {{ scope.row.certificate_number }}
                        </a>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Validation Link "
                    :prop="'validation_link'"
                    :width="$vuetify.display.width <= 2600 ? 220 : ''"
                    :min-width="220"
                    sortable
                  >
                    <template #default="scope">
                      <el-tooltip
                        v-if="scope.row.validation_link"
                        effect="light"
                        placement="top"
                        :show-after="400"
                      >
                        <template #content>
                          <span style="word-break: break-all;">{{ scope.row.validation_link }}</span>
                        </template>
                        <a
                          :href="scope.row.validation_link"
                          target="_blank"
                          class="truncated-cell-link"
                        >
                          {{ scope.row.validation_link }}
                        </a>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Year Added'"
                    :prop="'year_added'"
                    :width="$vuetify.display.width <= 3000 ? 160 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Active Until'"
                    :prop="'active_until'"
                    :width="$vuetify.display.width <= 3000 ? 250 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Is Included'"
                    :prop="'is_included'"
                    :width="$vuetify.display.width <= 3000 ? 170 : ''"
                    :min-width="170"
                    sortable
                  >
                    <template #default="scope">
                      <svg v-if="
                          scope.row.is_included.toString().toUpperCase() ==
                            'TRUE' ||
                          scope.row.is_included.toString().toUpperCase() == 'YES'
                        " id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                      </svg>
                      <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                        <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                      </svg>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Change Date'"
                    :prop="'change_date'"
                    :width="$vuetify.display.width <= 3000 ? 170 : ''"
                    :min-width="170"
                    sortable
                  />
                  <el-table-column
                    :label="'Change Details'"
                    :prop="'change_details'"
                    :width="$vuetify.display.width <= 3000 ? 200 : ''"
                    :min-width="200"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.change_details == null
                          ? ""
                          : scope.row.change_details.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Change Type'"
                    :prop="'change_type'"
                    :width="$vuetify.display.width <= 3000 ? 170 : ''"
                    :min-width="170"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.change_type == null
                          ? ""
                          : scope.row.change_type.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Updated At'"
                    :prop="'charger_updated_at'"
                    :width="$vuetify.display.width <= 3000 ? 250 : ''"
                    :min-width="160"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.charger_updated_at == null
                          ? ""
                          : scope.row.charger_updated_at.replace("T", " ").substring(0, 19)
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 3
                    "
                    :label="'Motion Charger ID'"
                    :prop="'charger_id'"
                    :width="$vuetify.display.width <= 2500 ? 250 : ''"
                    :min-width="230"
                    sortable
                  />
                </el-table>
                </div>
                <!-- Charger Ports -->
                <div class="custom-table-design" v-else-if="chargerFilter == 4">
                <el-table
                  stripe
                  :data="PortDataList"
                  :fit="true"
                  height="650"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Site Name'"
                    :prop="'site_name'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="160"
                    sortable
                    v-if="chargerFilter"
                  />
                  <el-table-column
                    :label="'Charger ID'"
                    :prop="'charger_name'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Port ID'"
                    :prop="'port_id'"
                    :width="$vuetify.display.width <= 2500 ? 150 : ''"
                    :min-width="140"
                    sortable
                  />
                  <el-table-column
                    :label="'Port Type'"
                    :prop="'port_type'"
                    :width="$vuetify.display.width <= 2500 ? 180 : ''"
                    :min-width="160"
                    sortable
                  />
                  <el-table-column
                    :label="'Port Capacity KW'"
                    :prop="'port_capacity_kw'"
                    :width="$vuetify.display.width <= 2500 ? 250 : ''"
                    :min-width="230"
                    sortable
                  >
                  <template #default="scope">
                    {{
                    scope.row.port_capacity_kw == null
                        ? ""
                        : Number(scope.row.port_capacity_kw).toLocaleString()
                    }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Description'"
                    :prop="'description'"
                    :width="$vuetify.display.width <= 2500 ? 350 : ''"
                    :min-width="180"
                    sortable
                  />
                  <el-table-column
                    :label="'Customer'"
                    :prop="'customer'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="150"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  />
                  <el-table-column
                    :label="'Change Date'"
                    :prop="'change_date'"
                    :width="$vuetify.display.width <= 2500 ? 170 : ''"
                    :min-width="170"
                    sortable
                  />
                  <el-table-column
                    :label="'Change Details'"
                    :prop="'change_details'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="200"
                    sortable
                    >
                    <template #default="scope">
                      {{
                      scope.row.change_details == null
                          ? ""
                          : scope.row.change_details.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Change Type'"
                    :prop="'change_type'"
                    :width="$vuetify.display.width <= 2500 ? 170 : ''"
                    :min-width="170"
                    sortable
                    >
                    <template #default="scope">
                      {{
                      scope.row.change_type == null
                          ? ""
                          : scope.row.change_type.toString().toUpperCase().replaceAll("_", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Updated At'"
                    :prop="'port_updated_at'"
                    :width="$vuetify.display.width <= 2500 ? 250 : ''"
                    :min-width="160"
                    sortable
                  >
                    <template #default="scope">
                      {{
                      scope.row.port_updated_at == null
                          ? ""
                          : scope.row.port_updated_at.replace("T", " ").substring(0, 19)
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="
                     $store.state.auth.user != null && $store.state.auth.user.is_admin && chargerFilter == 4
                    "
                    :label="'Motion Port ID'"
                    :prop="'unique_port_id'"
                    :width="$vuetify.display.width <= 2500 ? 200 : ''"
                    :min-width="200"
                    sortable
                  />
                </el-table>
                </div>

              <!-- <div class="d-flex justify-center">
                <el-pagination
                  small
                  background
                  layout="prev, pager, next"
                  :total="total_items"
                  v-model:page-size="page_size"
                  v-model:current-page="current_page"
                  @current-change="changePage"
                  class="my-4"
                />
              </div> -->

              <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
                <el-row class="row-bg" justify="space-between">
                  <el-col
                    :span="5"
                    class="d-flex justify-content-start align-items-center"
                  >
                    <el-select
                      v-model="perPageCount"
                      placeholder="Select"
                      size="small"
                      style="width: 70px"
                    >
                        <el-option label="5" :value="'5'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <!-- <el-option label="200" :value="'200'" /> -->
                        <!-- <el-option label="1k" :value="'1000'" /> -->
                    </el-select>
                  </el-col>
                  <el-col
                    :span="8"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <el-pagination
                      small
                      background
                      layout="prev, pager, next"
                      :total="total_items"
                      v-model:page-size="page_size"
                      v-model:current-page="current_page"
                      @current-change="changePage"
                      class="my-4"
                    />
                  </el-col>
                  <el-col
                    :span="5"
                    class="d-flex justify-content-end align-items-center"
                  >
                    <span class="text-white">
                      {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                        current_page * perPageCount > total_items
                          ? total_items.toLocaleString()
                          : (current_page * perPageCount).toLocaleString()
                      }}
                      of {{ total_items.toLocaleString() }}
                    </span>
                  </el-col>
                </el-row>
              </div>

              <div class="custom-pagination" v-if="$vuetify.display.width < 700">
                <el-row class="row-bg" justify="space-between">
                  <el-col
                    :span="24"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <el-pagination
                      small
                      background
                      layout="prev, pager, next"
                      :total="total_items"
                      v-model:page-size="page_size"
                      v-model:current-page="current_page"
                      @current-change="changePage"
                      class="my-4"
                    />
                  </el-col>
                  <el-col
                    :span="10"
                    class="d-flex justify-content-end align-items-center"
                  >
                    <el-select
                      v-model="perPageCount"
                      placeholder="Select"
                      size="small"
                      style="width: 70px"
                    >
                        <el-option label="5" :value="'5'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <!-- <el-option label="200" :value="'200'" /> -->
                        <!-- <el-option label="1k" :value="'1000'" /> -->
                    </el-select>
                  </el-col>
                  <el-col
                    :span="10"
                    class="d-flex justify-content-start align-items-center"
                  >
                    <span class="text-white">
                      {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                        current_page * perPageCount > total_items
                          ? total_items.toLocaleString()
                          : (current_page * perPageCount).toLocaleString()
                      }}
                      of {{ total_items.toLocaleString() }}
                    </span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import UserService from "../../../services/user.service";
import { convertToTitleCase, shorterLabel } from "../common/common-tools";

// EXPORT xlsx button
// import XLSX from "xlsx";

import { exportToExcel } from "../common/exportExcel";

const CHARGER_EXPORT_COLUMNS = {
  all: [
    { key: "site_name", label: "Site Name" },
    { key: "charger_name", label: "Charger ID" },
    { key: "port_id", label: "Port ID" },
    { key: "charger_type", label: "Charger Type" },
    { key: "charger_capacity_kW", label: "Charger Capacity (kW)" },
    { key: "port_type", label: "Port Type" },
    { key: "port_capacity_kw", label: "Port Capacity (kW)" },
    { key: "make", label: "Make" },
    { key: "model", label: "Model" },
    { key: "charging_partner", label: "Charging Partner" },
    { key: "address_comment", label: "Address Comment" },
    { key: "street_number", label: "Street Number" },
    { key: "street_name", label: "Street Name" },
    { key: "suburb", label: "Suburb" },
    { key: "city", label: "City" },
    { key: "postcode", label: "Postcode" },
    { key: "state", label: "State (County/Province)" },
    { key: "country", label: "Country" },
    { key: "lat", label: "Latitude" },
    { key: "lng", label: "Longitude" },
    { key: "install_date", label: "Install Date" },
    { key: "operational_date", label: "Operational Date" },
    { key: "decommissioning_date", label: "Decommissioning Date" },
    { key: "onsite_renewable", label: "On-Site Renewable" },
    { key: "onsite_battery", label: "Battery" },
    { key: "site_description", label: "Site Description" },
    { key: "charger_description", label: "Charger Description" },
    { key: "port_description", label: "Port Description" },
    { key: "customer", label: "Customer" },
    { key: "elec_region", label: "Elec Region" },
    { key: "certificate_number", label: "Certificate Number" },
    { key: "validation_link", label: "Validation Link" },
    { key: "year_added", label: "Year Added" },
    { key: "active_until", label: "Active Until" },
    { key: "included_in_project", label: "Is Included" },
    { key: "created_at", label: "Created At" },
    { key: "change_date", label: "Change Date" },
    { key: "change_details", label: "Change Details" },
    { key: "change_type", label: "Change Type" },
    { key: "motion_site_id", label: "Motion Site ID" },
    { key: "motion_charger_id", label: "Motion Charger ID" },
    { key: "motion_port_id", label: "Motion Port ID" },
  ],
  charging_sites: [
    { key: "site_name", label: "Site Name" },
    { key: "address_comment", label: "Address Comment" },
    { key: "street_number", label: "Street Number" },
    { key: "street_name", label: "Street Name" },
    { key: "suburb", label: "Suburb" },
    { key: "city", label: "City" },
    { key: "postcode", label: "Postcode" },
    { key: "state", label: "State (County/Province)" },
    { key: "country", label: "Country" },
    { key: "description", label: "Description" },
    { key: "customer", label: "Customer" },
    { key: "elec_region", label: "Elec Region" },
    { key: "change_date", label: "Change Date" },
    { key: "change_details", label: "Change Details" },
    { key: "change_type", label: "Change Type" },
    { key: "site_updated_at", label: "Updated At" },
    { key: "charger_site_id", label: "Motion Site ID" },
  ],
  chargers: [
    { key: "site_name", label: "Site Name" },
    { key: "charger_name", label: "Charger ID" },
    { key: "charger_type", label: "Charger Type" },
    { key: "charger_capacity_kW", label: "Charger Capacity (kW)" },
    { key: "make", label: "Make" },
    { key: "model", label: "Model" },
    { key: "charging_partner", label: "Charging Partner" },
    { key: "install_date", label: "Install Date" },
    { key: "operational_date", label: "Operational Date" },
    { key: "decommissioning_date", label: "Decommissioning Date" },
    { key: "onsite_renewable", label: "On-Site Renewable" },
    { key: "onsite_battery", label: "Battery" },
    { key: "description", label: "Description" },
    { key: "customer", label: "Customer" },
    { key: "certificate_number", label: "Certificate Number" },
    { key: "validation_link", label: "Validation" },
    { key: "year_added", label: "Year Added" },
    { key: "active_until", label: "Active Until" },
    { key: "is_included", label: "Is Included" },
    { key: "change_date", label: "Change Date" },
    { key: "change_details", label: "Change Details" },
    { key: "change_type", label: "Change Type" },
    { key: "charger_updated_at", label: "Updated At" },
    { key: "charger_id", label: "Motion Charger ID" },
  ],
  ports: [
    { key: "site_name", label: "Site Name" },
    { key: "charger_name", label: "Charger ID" },
    { key: "port_id", label: "Port ID" },
    { key: "port_type", label: "Port Type" },
    { key: "port_capacity_kw", label: "Port Capacity KW" },
    { key: "description", label: "Description" },
    { key: "customer", label: "Customer" },
    { key: "change_date", label: "Change Date" },
    { key: "change_details", label: "Change Details" },
    { key: "change_type", label: "Change Type" },
    { key: "port_updated_at", label: "Updated At" },
    { key: "unique_port_id", label: "Motion Port ID" },
  ],
};

function chargerExportColumns(tab) {
  const columns = CHARGER_EXPORT_COLUMNS[tab] || [];
  return {
    headerKeys: columns.map((column) => column.key),
    headerLabels: columns.reduce((labels, column) => {
      labels[column.key] = column.label;
      return labels;
    }, {}),
  };
}

export default {
  props: {
    filterProp: {
      type: Object,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      AllDataList: [],
      SiteDataList: [],
      ChargerDataList: [],
      PortDataList: [],
      search: "",
      current_page: 1,
      page_size: 25,
      total_items: 50,
      loading: false,
      chargerFilter: 1,
      perPageCount: 25,
      filter: {
        customer_id: null,
        start_date: null,
        end_date: null,
        search: "",
        country: "",
        elec_region: "",
      },

      selectedSearchBy: 'site_name',
      selectedTableTab: 'all',
      // search_by dropdown list
      search_by_dropdown: {
        all: ['site_name', 'charger_id', 'elec_region', 'postcode', 'model', 'make', 'charger_capacity'],
        admin_all: ['site_name', 'charger_id', 'elec_region', 'postcode', 'model', 'make', 'charger_capacity', 'motion_site_id', 'motion_charger_id', 'motion_port_id','created_at', 'updated_at'],
        charging_sites: ['site_name', 'city', 'street_name', 'suburb', 'address_comment'],
        chargers: ['site_name', 'charger_id', 'model', 'make', 'charger_capacity'],
        ports: ['site_name', 'charger_id', 'port_id','port_type', 'port_capacity'],
      },

      
    };
  },
  watch: {
    // update selected table tab when chargerFilter changed
    chargerFilter: {
      handler: function (newVal) {
        this.selectedSearchBy = 'site_name'; // reset search by when tab change
        this.setSelectTableTab(newVal);
      }
    },


    filterProp: {
      handler: function (newVal) {
        this.filter = newVal;
        // this.fetchData(this.current_page, this.search);
        if (this.chargerFilter == 1) {
          this.fetchData(this.current_page, this.search);
        } else if (this.chargerFilter == 2) {
          this.fetchAllChargingSite(this.current_page, this.search);
        } else if (this.chargerFilter == 3) {
          this.fetchAllCharger(this.current_page, this.search);
        } else {
          this.fetchAllPort(this.current_page, this.search);
        }
      },
      deep: true,
    },

    current_page: function (newVal) {
      this.current_page = newVal;
      if (this.chargerFilter == 1) {
        this.fetchData(this.current_page, this.search);
      } else if (this.chargerFilter == 2) {
        this.fetchAllChargingSite(this.current_page, this.search);
      } else if (this.chargerFilter == 3) {
        this.fetchAllCharger(this.current_page, this.search);
      } else {
        this.fetchAllPort(this.current_page, this.search);
      }
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      if (this.chargerFilter == 1) {
        this.fetchData(this.current_page, this.search);
      } else if (this.chargerFilter == 2) {
        this.fetchAllChargingSite(this.current_page, this.search);
      } else if (this.chargerFilter == 3) {
        this.fetchAllCharger(this.current_page, this.search);
      } else {
        this.fetchAllPort(this.current_page, this.search);
      }
    },
  },
  mounted() {

    // this.fetchData(this.current_page, this.search);
    if (this.chargerFilter == 1) {
      // this.fetchData(this.current_page, this.search);
      return;
    } else if (this.chargerFilter == 2) {
      this.fetchAllChargingSite(this.current_page, this.search);
    } else if (this.chargerFilter == 3) {
      this.fetchAllCharger(this.current_page, this.search);
    } else {
      this.fetchAllPort(this.current_page, this.search);
    }
  },
  methods: {

    convertShorterLabel(label, setLength, setMinLength, addOnLabel="") {
      return shorterLabel(label, setLength, setMinLength, addOnLabel);
    },

    convertLabel(str) {
      return convertToTitleCase(str);
    },

    // set select table tabs labels with selected from radio box 1, 2, 3, 4,
    setSelectTableTab(val){
      switch (val) {
        case '1':
          this.selectedTableTab = 'all'
          break;
        case '2':
          this.selectedTableTab = 'charging_sites'
          break;
        case '3':
          this.selectedTableTab = 'chargers'
          break;
        case '4':
          this.selectedTableTab = 'ports'
          break;
        default:
          break;
      }
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
      // console.log('selected search by', this.selectedSearchBy);
    },

    async downloadChargersXlsx(dataList) {
      try {
        // console.log("tableData", dataList);

        const skipKey_all = ["customer_id", "motion_site_id", "motion_charger_id", "motion_port_id", "created_at", "updated_at"];
        const skipKey_admin_all = ["customer_id"];
        const skipKey_charging_sites = ["customer_id","charger_site_id","unique_charger_id"];
        const skipKey_chargers = ["charger_id","customer_id","charger_site_id"]
        const skipKey_ports = ["customer_id","unique_port_id","operational_date"]

        const skipKeys = (this.$store.state.auth.user != null && this.$store.state.auth.user.is_admin && this.chargerFilter == 1) ? skipKey_admin_all
          : (this.selectedTableTab == "all") ? skipKey_all 
          : this.selectedTableTab == "charging_sites" ? skipKey_charging_sites 
          : (this.selectedTableTab == "chargers") ? skipKey_chargers 
          : (this.selectedTableTab == "ports") ? skipKey_ports 
          : [];

        const tempFileName = this.selectedTableTab == "all" ? "Charger Schedule" : this.selectedTableTab == "charging_sites" ? "Charging Sites" : this.selectedTableTab == "chargers" ? "Chargers" : this.selectedTableTab == "ports" ? "Ports" : "";
        const fileName = `chargers_${tempFileName}.xlsx`; // File name
        const newWorksheetName = `${tempFileName}`; // Worksheet name
        const title = `${tempFileName}`; // Title for the Excel file

        // console.log("debug");
        // console.log("fileName", fileName, "newWorksheetName", newWorksheetName, "title", title, "skipKeys", skipKeys);
        
        const { headerKeys, headerLabels } = chargerExportColumns(this.selectedTableTab);

        try {

        
        await exportToExcel({
          dataList,
          skipKeys,
          headerKeys,
          headerLabels,
          fileName,
          newWorksheetName,
          title,
        });
      } catch (err) {
        console.log("error when export excel", err.message);
        
      }

      } catch (error) {
        console.error("error when download file", error);
      }
    },

    // export xslx file clients_data.xlsx
    // async downloadChargersXlsx() {
    //   try {
    //     const response = await userService.DashboardChargersXlsx();

    //     const blob = new Blob([response.data], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });

    //     const link = document.createElement("a");
    //     link.href = URL.createObjectURL(blob);
    //     link.download = "clients_data.xlsx";
    //     document.body.appendChild(link);
    //     link.click();

    //     // Cleanup
    //     URL.revokeObjectURL(link.href);
    //     document.body.removeChild(link);
    //   } catch (error) {
    //     console.error("error when download file", error);
    //   }
    // },

    // export table data as xlsx file
    async handleExportFile() {
      const tempFilter = {
          customer_id: this.filterProp.customer_id,
          start_date: this.filterProp.startDate,
          end_date: this.filterProp.endDate,
          search_by: this.selectedSearchBy,
          search: this.search,
          country: this.filterProp.country || "",
          elec_region: this.filterProp.elec_region || "",
          ...this.chargerSessionRequestFields(),
        }
      if (this.chargerFilter == 1) {
        // this.excelDataList = this.AllDataList;
        await UserService.GetChargerList(tempFilter, 1, this.perPageCount, true).then((res) => {
          this.excelDataList = res.data.chargers;
        }).catch((error) => {
          console.log("error when fetching data for Charger All excel", error);
          return;
        });
      } else if (this.chargerFilter == 2) {
        // this.excelDataList = this.SiteDataList;
        await UserService.GetAllChargingSite(tempFilter, 1, this.perPageCount, true).then((res) => {
          this.excelDataList = res.data.charging_sites;
        }).catch((error) => {
          console.log("error when fetching data for Charger charging sites excel", error);
          return;
        });
      } else if (this.chargerFilter == 3) {
        // this.excelDataList = this.ChargerDataList;
        await UserService.GetAllCharger(tempFilter, 1, this.perPageCount, true).then((res) => {
          this.excelDataList = res.data.chargers;
        }).catch((error) => {
          console.log("error when fetching data for Charger chargers excel", error);
          return;
        });
      } else if (this.chargerFilter == 4) {
        // this.excelDataList = this.ChargerDataList;
        await UserService.GetAllPort(tempFilter, 1, this.perPageCount, true).then((res) => {
          this.excelDataList = res.data.charger_ports;
        }).catch((error) => {
          console.log("error when fetching data for Charger ports excel", error);
          return;
        });
      } else {
        this.excelDataList = [];
        console.log("can't find data for selected tab, check error");
        return;
      }

      if (this.excelDataList.length > 0) {
        // pass exceldatalist to next step
        this.downloadChargersXlsx(this.excelDataList);
      }
    },

    chargerSessionRequestFields() {
      return {
        mp_id: this.filterProp && this.filterProp.mp_id,
        with_sessions: this.filterProp && this.filterProp.with_sessions,
        with_sessions_and_abatement: this.filterProp && this.filterProp.with_sessions_and_abatement,
      };
    },
    fetchData(page, search) {
      this.filter = {
        customer_id: this.filterProp.customer_id,
        start_date: this.filterProp.startDate,
        end_date: this.filterProp.endDate,
        search_by: this.selectedSearchBy,
        search: search,
        elec_region: this.filterProp.elec_region || "",
        country: this.filterProp.country || "",
        ...this.chargerSessionRequestFields(),
      };
      this.loading = true;
      UserService.GetChargerList(this.filter, page, this.perPageCount)
        .then(
          (response) => {
            this.total_items = response.data.total_record;
            this.AllDataList = response.data.chargers;
            // console.log("GetChargerList", response.data);
            
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    fetchAllChargingSite(page, search) {
      let filter = {
        customer_id: this.filterProp.customer_id,
        search_by: this.selectedSearchBy,
        search: search,
        elec_region: this.filterProp.elec_region || "",
        country: this.filterProp.country || "",
      };
      this.loading = true;
      UserService.GetAllChargingSite(filter, page, this.perPageCount)
        .then(
          (response) => {
            this.total_items = response.data.total_record;
            this.SiteDataList = response.data.charging_sites;


          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          // if (error.response.status == 401) {
          //   this.$router.push({
          //     path: "/",
          //   });
          // }
        })
        .finally(() => (this.loading = false));
    },
    fetchAllCharger(page, search) {
      let filter = {
        customer_id: this.filterProp.customer_id,
        search_by: this.selectedSearchBy,
        search: search,
        elec_region: this.filterProp.elec_region || "",
        country: this.filterProp.country || "",
      };
      this.loading = true;
      UserService.GetAllCharger(filter, page, this.perPageCount)
        .then(
          (response) => {
            this.total_items = response.data.total_record;
            this.ChargerDataList = response.data.chargers;



          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    fetchAllPort(page, search) {
      let filter = {
        customer_id: this.filterProp.customer_id,
        search_by: this.selectedSearchBy,
        search: search,
        elec_region: this.filterProp.elec_region || "",
        country: this.filterProp.country || "",
      };
      this.loading = true;
      UserService.GetAllPort(filter, page, this.perPageCount)
        .then(
          (response) => {
            this.total_items = response.data.total_record;
            this.PortDataList = response.data.charger_ports;

    

          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    handleRefresh() {
      this.current_page = 1;
      if (this.chargerFilter == 1) {
        this.fetchData(this.current_page, this.search);
      } else if (this.chargerFilter == 2) {
        this.fetchAllChargingSite(this.current_page, this.search);
      } else if (this.chargerFilter == 3) {
        this.fetchAllCharger(this.current_page, this.search);
      } else {
        this.fetchAllPort(this.current_page, this.search);
      }
    },
    selectChargerFilter(data) {
      this.current_page = 1;
      if (data == 1) {
        this.fetchData(this.current_page, this.search);
      } else if (data == 2) {
        this.fetchAllChargingSite(this.current_page, this.search);
      } else if (data == 3) {
        this.fetchAllCharger(this.current_page, this.search);
      } else {
        this.fetchAllPort(this.current_page, this.search);
      }
    },
  },
};
</script>

<style scoped>
.truncated-cell-link {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-table-design :deep(th.el-table__cell > .cell) {
  white-space: nowrap;
}
</style>

